/* eslint-disable no-else-return */
import React from 'react';
import styled from 'styled-components';
import settings from '../../../settings';

const Component = (() => {
  if (settings.product === 'theda')
    return React.lazy(
      () =>
        import(
          /* webpackMode: 'eager' */
          './index.theda'
        ),
    );
  else if (settings.product === 'pandemic')
    return React.lazy(
      () =>
        import(
          /* webpackMode: 'eager' */
          './index.pandemic'
        ),
    );
  else if (settings.product === 'aerosim')
    return React.lazy(
      () =>
        import(
          /* webpackMode: 'eager' */
          './index.aerosim'
        ),
    );
  else if (settings.product === 'airflowsim')
    return React.lazy(
      () =>
        import(
          /* webpackMode: 'eager' */
          './index.airflowsim'
        ),
    );
  else if (settings.product === 'pluggsim')
    return React.lazy(
      () =>
        import(
          /* webpackMode: 'eager' */
          './index.pluggsim'
        ),
    );
  else if (settings.product === 'neasim')
    return React.lazy(
      () =>
        import(
          /* webpackMode: 'eager' */
          './index.neasim'
        ),
    );
  else if (settings.product === 'zieglersim')
    return React.lazy(
      () =>
        import(
          /* webpackMode: 'eager' */
          './index.zieglersim'
        ),
    );
  else if (settings.product === 'heatensim')
    return React.lazy(
      () =>
        import(
          /* webpackMode: 'eager' */
          './index.heatensim'
        ),
    );
  else if (settings.product === 'vaillantsim')
    return React.lazy(
      () =>
        import(
          /* webpackMode: 'eager' */
          './index.vaillantsim'
        ),
    );
  else if (settings.product === 'weisstechniksim')
    return React.lazy(
      () =>
        import(
          /* webpackMode: 'eager' */
          './index.weisstechniksim'
        ),
    );
  else if (settings.product === 'bdrsim')
    return React.lazy(
      () =>
        import(
          /* webpackMode: 'eager' */
          './index.bdrsim'
        ),
    );
  else if (settings.product === 'etsim')
    return React.lazy(
      () =>
        import(
          /* webpackMode: 'eager' */
          './index.etsim'
        ),
    );
  else if (settings.product === 'virtualhousesim')
    return React.lazy(
      () =>
        import(
          /* webpackMode: 'eager' */
          './index.virtualhousesim'
        ),
    );
  else if (settings.product === 'sbcsim')
    return React.lazy(
      () =>
        import(
          /* webpackMode: 'eager' */
          './index.sbcsim'
        ),
    );
  else if (settings.product === 'thewasim')
    return React.lazy(
      () =>
        import(
          /* webpackMode: 'eager' */
          './index.thewasim'
        ),
    );
  else if (settings.product === 'hx' || settings.product === 'logph' || settings.product === 'mccabethiele')
    return React.lazy(
      () =>
        import(
          /* webpackMode: 'eager' */
          './index.diagram'
        ),
    );
  else
    return React.lazy(
      () =>
        import(
          /* webpackMode: 'eager' */
          './index.default'
        ),
    );
})();

const Logo = ({ className, showSimpleVersion = false }: { className: string; showSimpleVersion: boolean }) => (
  <React.Suspense fallback={null}>
    <Component className={className} showSimpleVersion={showSimpleVersion} />
  </React.Suspense>
);

export default styled(Logo)`` as any;
